module.exports = __webpack_public_path__ + "img/park2.2e899d8d.png";